var Handlebars = require("handlebars/dist/handlebars");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "\r\n<SOAP:Envelope xmlns:SOAP=\"http://schemas.xmlsoap.org/soap/envelope/\">\r\n  <SOAP:Body>\r\n    <UploadDocument xmlns=\"http://dla.mil/ems/bpm/content_server\">\r\n      <DocumentTypeID>"
    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"metadata") : depth0)) != null ? lookupProperty(stack1,"documentTypeId") : stack1), depth0))
    + "</DocumentTypeID>\r\n      <FileName>Upload:FileName1</FileName>\r\n      <FilePath>Upload:FilePath1</FilePath>\r\n    </UploadDocument>\r\n  </SOAP:Body>\r\n</SOAP:Envelope>";
},"useData":true});